import React, { useState } from 'react';
import { Tabs, Card, Form, Input, Switch, Button, message, Divider } from 'antd';
import { SafetyCertificateOutlined, LockOutlined } from '@ant-design/icons';
import './SecurityCompliance.css';

const { TabPane } = Tabs;

function SecurityCompliance() {
  const [activeTab, setActiveTab] = useState('gdpr');
  const [gdprForm] = Form.useForm();
  const [twoFAForm] = Form.useForm();

  const handleGDPRSubmit = async (values) => {
    try {
      // TODO: Implement API call to save GDPR settings
      console.log('GDPR Settings:', values);
      message.success('GDPR settings saved successfully');
    } catch (error) {
      message.error('Failed to save GDPR settings');
    }
  };

  const handle2FASubmit = async (values) => {
    try {
      // TODO: Implement API call to save 2FA settings
      console.log('2FA Settings:', values);
      message.success('Two-Factor Authentication settings saved successfully');
    } catch (error) {
      message.error('Failed to save 2FA settings');
    }
  };

  return (
    <div className="security-compliance-container">
      <div className="page-header">
        <h1>Security & Compliance</h1>
        <p>Manage security settings and compliance requirements</p>
      </div>

      <Tabs activeKey={activeTab} onChange={setActiveTab} className="security-tabs">
        <TabPane
          tab={
            <span>
              <SafetyCertificateOutlined />
              GDPR/Privacy Settings
            </span>
          }
          key="gdpr"
        >
          <Card title="GDPR & Privacy Configuration">
            <Form
              form={gdprForm}
              layout="vertical"
              onFinish={handleGDPRSubmit}
              initialValues={{
                data_retention_days: 365,
                cookie_consent_enabled: true,
                data_export_enabled: true,
                right_to_be_forgotten: true,
                privacy_policy_url: '',
                dpo_email: '',
              }}
            >
              <Form.Item
                name="data_retention_days"
                label="Data Retention Period (Days)"
                rules={[{ required: true }]}
              >
                <Input type="number" placeholder="365" />
              </Form.Item>

              <Form.Item
                name="cookie_consent_enabled"
                label="Cookie Consent Banner"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="data_export_enabled"
                label="Enable Data Export for Users"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="right_to_be_forgotten"
                label="Right to Be Forgotten (Account Deletion)"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Divider />

              <Form.Item
                name="privacy_policy_url"
                label="Privacy Policy URL"
              >
                <Input placeholder="https://yoursite.com/privacy" />
              </Form.Item>

              <Form.Item
                name="dpo_email"
                label="Data Protection Officer Email"
                rules={[{ type: 'email' }]}
              >
                <Input placeholder="dpo@yourcompany.com" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save GDPR Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>

        <TabPane
          tab={
            <span>
              <LockOutlined />
              Two-Factor Authentication
            </span>
          }
          key="2fa"
        >
          <Card title="Two-Factor Authentication Settings">
            <Form
              form={twoFAForm}
              layout="vertical"
              onFinish={handle2FASubmit}
              initialValues={{
                enforce_2fa_superadmin: true,
                enforce_2fa_admin: false,
                enforce_2fa_agency: false,
                enforce_2fa_client: false,
                allow_sms_2fa: true,
                allow_app_2fa: true,
                allow_email_2fa: false,
              }}
            >
              <h3>Enforce 2FA by Role</h3>
              
              <Form.Item
                name="enforce_2fa_superadmin"
                label="Super Admins"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="enforce_2fa_admin"
                label="Admins"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="enforce_2fa_agency"
                label="Agencies"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="enforce_2fa_client"
                label="Clients"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Divider />

              <h3>2FA Methods</h3>

              <Form.Item
                name="allow_sms_2fa"
                label="SMS Authentication"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="allow_app_2fa"
                label="Authenticator App (Google Authenticator, Authy)"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="allow_email_2fa"
                label="Email Authentication"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save 2FA Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default SecurityCompliance;
